export const industries = {
  "Feed" : [
    "Feed",
    "Pet"
  ],
  "Flavor" : [
    "Flavor"
  ],
  "Food" : [
    "Bakery",
    "Confectionary",
    "Dairy",
    "Dairy-like",
    "Distributor",
    "Drink",
    "Filling",
    "Ice Cream",
    "Oils & Fats",
    "Other",
    "Ready meal",
    "Snack",
    "Spread",
    "Beverage",
    "Meat and Sea",
    "Trader",
    "Blender"
  ],
  "Food Ingredient" : [
    "Food Ingredient"
  ],
  "Nutrition" : [
    "Other",
    "Infant",
    "Clinical",
    "Sport and Diet",
    "Food Supplement",
    "Senior"
  ],
  "Other" : [
    "Other",
    "Technical"
  ],
  "Pharmaceutical" : [
    "Animal health",
    "Human health",
    "Other pharma",
    "Food Supplement",
    "Cosmetic",
    "Phytosanitary"
  ],
  "QSR" : [
    "QSR"
  ]
}

